var map = {
	"./bootstrap.png": [
		2071,
		71
	],
	"./code.png": [
		3986,
		986
	],
	"./cpp.png": [
		9246,
		246
	],
	"./css.png": [
		1652,
		652
	],
	"./express.png": [
		5093,
		93
	],
	"./figma.png": [
		9217,
		217
	],
	"./git.png": [
		5705,
		705
	],
	"./github.png": [
		9380,
		380
	],
	"./html.png": [
		8082,
		82
	],
	"./js.png": [
		7628,
		628
	],
	"./mongo.png": [
		8941,
		941
	],
	"./mysql.png": [
		5575,
		575
	],
	"./node.png": [
		2997,
		997
	],
	"./postman.png": [
		4015,
		15
	],
	"./python.png": [
		4531,
		531
	],
	"./react.png": [
		3896,
		896
	],
	"./reactnative.png": [
		9433,
		433
	],
	"./tailwind.png": [
		2497,
		497
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9275;
module.exports = webpackAsyncContext;